import { call, delay, put, select, takeEvery } from 'redux-saga/effects';
import * as documentsActions from '../actions/documents';
import { errorProcessing } from '../../../../Employees/api/errorProcessing';
import { getAllOrdersRequest } from '../../api/documents/getAllOrdersRequest';
import { getFilterOrdersRequest } from '../../api/documents/getFilterOrdersRequest';
import history from '../../../../../common/history';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllOrdersSaga() {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getAllOrdersRequest, activeProfileId);
      let orderTypes = {};
      let ordersStat = {};
      let drivers = [];
      response.forEach(item => {
        if (item.state.statusKeyGroup) {
          const { statusKeyGroup } = item.state;
          if (!orderTypes.hasOwnProperty(statusKeyGroup)) {
            orderTypes[statusKeyGroup] = {
              key: statusKeyGroup,
              status: item.state.status,
            };
          }
          ordersStat.hasOwnProperty(statusKeyGroup)
            ? ordersStat[statusKeyGroup]++
            : (ordersStat[statusKeyGroup] = 1);
        }
        // собираем всех водителей и исключаем дубликаты
        if (item.driver && item.driver.length > 0) {
          item.driver.forEach(driver => {
            if (!drivers.some(item => item.id === driver.id)) {
              drivers.push(driver);
            }
          });
        }
      });
      yield put(
        documentsActions.getAllOrdersForDocumentsSuccess({
          orderTypes: Object.keys(orderTypes).map(key => orderTypes[key]),
          orders: response,
          ordersStat,
          drivers,
        })
      );
    } catch (e) {
      yield put(
        documentsActions.getAllOrdersForDocumentsFailure(errorProcessing(e))
      );
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(documentsActions.getAllOrdersForDocuments())
      : history.push('/authorization/profiles');
  }
}

function* getFilterOrdersSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getFilterOrdersRequest,
        activeProfileId,
        action.payload
      );
      let drivers = [];
      let ordersStat = {};
      response.forEach(item => {
        if (item.state.statusKeyGroup) {
          const { statusKeyGroup } = item.state;
          ordersStat.hasOwnProperty(statusKeyGroup)
            ? ordersStat[statusKeyGroup]++
            : (ordersStat[statusKeyGroup] = 1);
        }
        // собираем всех водителей и исключаем дубликаты
        if (item.driver && item.driver.length > 0) {
          item.driver.forEach(driver => {
            if (!drivers.some(item => item.id === driver.id)) {
              drivers.push(driver);
            }
          });
        }
      });
      yield put(
        documentsActions.getFilterOrdersForDocumentsSuccess({
          orders: response,
          ordersStat,
          drivers,
        })
      );
    } catch (err) {
      console.log(err);
      yield put(
        documentsActions.getFilterOrdersForDocumentsFailure(
          errorProcessing(err)
        )
      );
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(documentsActions.getFilterOrdersForDocuments(action.payload))
      : history.push('/authorization/profiles');
  }
}

export function* ordersConfigWatcher() {
  yield takeEvery(
    documentsActions.getAllOrdersForDocuments.toString(),
    getAllOrdersSaga
  );
  yield takeEvery(
    documentsActions.getFilterOrdersForDocuments.toString(),
    getFilterOrdersSaga
  );
}
